import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/api/authentication/authentication.service';
import { ConstantsService } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { AuthResponse } from 'src/app/shared/models/api-response/auth-response';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	username = '';
	password = '';

	alerts: any[] = [];
	wrongCredentialMessage = {
		type: 'danger',
		msg: `Mot de passe ou nom d'utilisateur incorrect. Veuillez
        réessayer.`
	};

	errorMessage = {
		type: 'danger',
		msg: `Une erreur est survenue, veulliez réessayer dans
        quelques instants. Si l'erreur persiste, contactez le
        support technique.`
	};

	isTryingToLogin: boolean = false;

	constructor(
		private authService: AuthenticationService,
		private router: Router,
		private constantsService: ConstantsService,
		private facade: FacadeService
	) {}

	ngOnInit() {
		if (this.facade.dataStorageService.getUser()) {
			if (this.facade.dataStorageService.isPrescriber()) {
				this.router.navigateByUrl('/prescriber/booking');
			} else if (!this.facade.dataStorageService.isIntervenant()) {
				this.router.navigateByUrl('/dashboard');
			} else {
				this.router.navigateByUrl('/planning');
			}
		}
	}

	signIn() {
		this.alerts = [];
		this.isTryingToLogin = true;
		this.authService.authenticate(this.username, this.password).subscribe({
			next: (resp: AuthResponse) => {
				//this.logger.log('authenticate response : ', resp);

				this.facade.dataStorageService.setJwtToken(resp.token);
				this.facade.dataStorageService.setUser(resp.user);
				this.facade.dataStorageService.setRefreshNotificationRateInSeconds(
					resp.refreshNotificationRateInSeconds
				);

				const serviceCenterParameters =
					this.facade.dataStorageService.getUser()?.employee?.serviceCenter
						.serviceCenterParameters;

				serviceCenterParameters?.forEach((centerParam) =>
					this.facade.dataStorageService.setParam(
						centerParam.key,
						centerParam.value
					)
				);

				this.constantsService.updateUserAuthority(resp.user.role.id);
				this.isTryingToLogin = false;
				if (this.facade.dataStorageService.isPrescriber()) {
					this.router.navigateByUrl('/prescriber/booking');
				} else if (!this.facade.dataStorageService.isIntervenant()) {
					this.router.navigateByUrl('/dashboard');
				} else {
					this.router.navigateByUrl('/planning');
				}
			},
			error: (errorCode) => {
				this.isTryingToLogin = false;
				if (errorCode === 401) {
					this.alerts.push(this.wrongCredentialMessage);
				} else {
					this.alerts.push(this.errorMessage);
				}
			}
		});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}
}
